module.exports = __webpack_public_path__ + "img/end_marker.38f375f0.png";